import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USERS } from "./apiRoutes";

/** Users > Add User "Use Existing User" (admin): link the existing user to the community, fill blanks. */
const useMergeOwnerMutation = (queryParams?: UseMutationOptions<any, Error, { userId: number; data: any }, unknown>) =>
  useMutation({
    mutationFn: async ({ userId, data }: { userId: number; data: any }) =>
      await axiosAuth.post(`${GET_USERS}/owners/${userId}/merge`, data),
    ...queryParams,
  });

export default useMergeOwnerMutation;
